import { smallBold } from "./typography";

export const actionButtonStyles = () => ({
  ...smallBold,
  fontWeight: 500,
  backgroundColor: "#0D3D51",
  color: "white",
  borderRadius: "0",
  boxShadow: "2px 2px 4px rgba(0,0,0,0.1), -2px -2px 4px rgba(255,255,255,0.7)", // Reduced shadow spread
  textTransform: "none",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "#0B212F",
    boxShadow: "inset 4px 4px 8px #0B212F, inset -4px -4px 8px #0B212F",
  },
  padding: "2px 20px",
  fontSize: "12px",
  fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
});
